import { render, staticRenderFns } from "./ModalTicketTecnico.vue?vue&type=template&id=9a811a84&scoped=true"
import script from "./ModalTicketTecnico.vue?vue&type=script&lang=js"
export * from "./ModalTicketTecnico.vue?vue&type=script&lang=js"
import style0 from "./ModalTicketTecnico.vue?vue&type=style&index=0&id=9a811a84&prod&scoped=true&lang=css"
import style1 from "@/assets/css/ticketTecnico.css?vue&type=style&index=1&id=9a811a84&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a811a84",
  null
  
)

export default component.exports